// Preserve only a bounded invitation token, never an arbitrary redirect URL.
export function brandInvitationToken(search = '') {
  const params = new URLSearchParams(search);
  const token = params.get('brand_invitation') || params.get('invitation') || '';
  return /^[A-Za-z0-9_-]{32,512}$/.test(token) ? token : '';
}
export function brandInvitationDestination(search = '') {
  const token = brandInvitationToken(search);
  return token ? `/hq?invitation=${encodeURIComponent(token)}` : '';
}
export function brandAuthPath(destination, search = '') {
  const token = brandInvitationToken(search);
  return `/${destination}` + (token ? `?brand_invitation=${encodeURIComponent(token)}` : '');
}
